export const subscriptionsKeys = {
  all: [{ module: 'subscriptions' }] as const,
  details: () => [{ ...subscriptionsKeys.all[0], scope: 'detail' }] as const,
  detail: (subscriptionId: string) => [{ ...subscriptionsKeys.details()[0], subscriptionId }] as const,
  memberDetail: (baId: string, subscriptionId: string) =>
    [{ ...subscriptionsKeys.detail(subscriptionId)[0], baId, access: 'member' }] as const,
};
